/**
 * @Author: v_jppjpeng
 * @Date: 2023-11-15 16:02:10
 * @Explain: 下拉选择
 */
import classNames from 'classnames';
import { useMemo } from 'react';
// type
import type { SelectProps } from '../data.d';
// components
import CustomSelect from '../customSelect';

function Select(props: SelectProps & { allowScroll?: boolean }) {
  const { className, overlayClassName, ellipsis } = props;

  const customProps: SelectProps = useMemo(() => {
    const params = { ...props };
    return {
      ...params,
      className: classNames('default-td-select', className),
      overlayClassName: classNames(
        'default-td-select-popup',
        {
          'ellipsis-list': ellipsis,
        },
        overlayClassName,
      ),
    };
  }, [props, ellipsis, overlayClassName]);

  return <CustomSelect {...customProps} />;
}

export default Select;
